// extracted by mini-css-extract-plugin
module.exports = {"gender":"HeaderCell_gender__JnrAt","withIcon":"HeaderCell_withIcon__V6ZEh"};